import { useTranslation } from 'next-i18next';
import React, { useContext } from 'react';
import styled, { DefaultTheme, ThemeContext } from 'styled-components';
import MeetingIcon from '../../../../new-components/svg-icons/MeetingIcon';
import ButtonTextIcon from '../../../../new-components/ui/ButtonTextIcon';
import { useSelector } from 'react-redux';

interface BtnProps {
  clickHandler: () => void;
}

const RequestMeetingBtn = ({ clickHandler }: BtnProps): JSX.Element => {
  const theme = useContext(ThemeContext) as DefaultTheme;
  const { t } = useTranslation('contact');
  const isMobile = useSelector((state: any) => state.app.isMobile);

  return (
    <Container data-test="request-btn">
      <ButtonTextIcon
        backgroundColor={
          isMobile ? theme.light.colors.primaryBlue : 'transparent'
        }
        color={
          isMobile ? theme.light.colors.white : theme.light.colors.primaryBlue
        }
        fontSize={theme.font.sizes.s}
        icon={<MeetingIcon />}
        onClick={clickHandler}
        padding="8px auto"
        text={t('request_meeting')}
        backgroundHover="none"
        border={`1px solid ${theme.light.colors.primaryBlue}`}
        containerClass="meeting-btn"
      />
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  margin-bottom: 16px;
  .meeting-btn {
    width: 100%;
    button {
      height: 45px;
      width: 100%;
      font-family: materialMedium;
      border-radius: 8px;
      @media screen and (max-width: ${props =>
          props.theme.breakPoints.tablet.max}) {
        /* margin-top: 16px; */
      }
    }
  }
`;
export default RequestMeetingBtn;
